import React from 'react'
import PrivateChatContainer from '../../../../Components/Applications/Chat/PrivateChat'

export default function PrivateChat() {
  return (
    <div className='page-body'>
        <PrivateChatContainer/>
    </div>
  )
}
